// extracted by mini-css-extract-plugin
export default {"p_content":"_4a201bcbdc"};